export default __webpack_public_path__ + "static/media/electrical.44b39930.jpg";